module.exports = __webpack_public_path__ + "static/none-user-avatar-icon-dca97ed632336f319034f494d58c0068.svg";